








































































































import useReplies from "@/composables/v2.1/useReplies";
import useChatInput from "@/composables/v3/useChatInput";
import useSendMessage from "@/composables/v3/useSendMessage";
import useTemplates from "@/composables/v3/useTemplates";
import useUpload from "@/composables/v3/useUpload";
import toastificationContent from "@/layouts/components/toastification/toastificationContent.vue";
import i18n from "@/libs/i18n";
import { useChannelsStore } from "@/store/useChannelsStore";
import { useChatsStore } from "@/store/useChatsStore";
import { useCustomersStore } from "@/store/useCustomersStore";
import { isChatAssignedToMeV21, shouldAssignV21 } from "@/utils/chats";
import MandatoryAssign from "@/views/modules/messaging-inbox/alerts/components/mandatoryAssign.vue";
import Reply from "@/views/modules/messaging-inbox/chat-log-entries/components/reply.vue";
import Attachments from "@/views/modules/messaging-inbox/compose/components/attachments.vue";
import DropdownMenu from "@/views/modules/messaging-inbox/compose/components/dropdownMenu.vue";
import EmojiPicker from "@/views/modules/messaging-inbox/compose/components/emojiPicker.vue";
import Message from "@/views/modules/messaging-inbox/compose/components/message.vue";
import Signature from "@/views/modules/messaging-inbox/compose/components/signature.vue";
import Templates from "@/views/modules/messaging-inbox/compose/components/templates.vue";
import { UploadDto } from "@saysimple-platform/dtos";
import { defineComponent, ref } from "@vue/composition-api";
import { useDropZone } from "@vueuse/core";
import {
    BButton,
    BCol,
    BDropdown,
    BDropdownItemButton,
    BForm,
    BFormFile,
    BFormInput,
    BFormTextarea,
    BInputGroup,
    BLink,
    BRow,
    BSpinner,
} from "bootstrap-vue";
import { useToast } from "vue-toastification/composition";
import ChatGptModal from "@/views/components/inbox/openai/chatGptModal.vue";
import { storeToRefs } from "pinia";

export default defineComponent({
    components: {
        BLink,
        ChatGptModal,
        MandatoryAssign,
        Attachments,
        BButton,
        BCol,
        BDropdown,
        BDropdownItemButton,
        BForm,
        BFormFile,
        BFormInput,
        BFormTextarea,
        BInputGroup,
        BRow,
        BSpinner,
        DropdownMenu,
        EmojiPicker,
        Message,
        Reply,
        Signature,
        Templates,
    },
    setup() {
        const chatsStore = useChatsStore();
        const channelsStore = useChannelsStore();
        const toast = useToast();
        const { selectedTemplate, isTemplate, hasMediaTemplateFilesUploaded } = useTemplates();
        const { customerSettings } = storeToRefs(useCustomersStore());

        //----------------------------------------------------------------------
        // Three ways to upload files. All will use finally use the uploadFiles function below:
        // 1.) With file dialog (onChange from VueUse's useFileDialog)
        // 2.) Ctrl+v paste
        // 3.) Drag and drop

        const { onChange } = useUpload();
        onChange((files) => uploadFiles(files as unknown as File[]));

        const dropZoneRef = ref(null);

        const uploadFiles = (files: File[]): void => {
            const { uploadMultiple } = useUpload();
            uploadMultiple(files, channelsStore.activeChatChannel)
                .then((response: UploadDto[]) => {
                    if (selectedTemplate.value.mediaType) {
                        hasMediaTemplateFilesUploaded.value = true;
                    }

                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("upload.Upload"),
                            text: i18n.tc("upload.success", response?.length),
                            icon: "check",
                            variant: "success",
                        },
                    });
                })
                .catch((error) => {
                    toast({
                        component: toastificationContent,
                        props: {
                            title: i18n.t("upload.Upload"),
                            text: error.message,
                            icon: "times",
                            variant: "danger",
                        },
                    });
                });
        };
        const { isOverDropZone } = useDropZone(dropZoneRef, uploadFiles);

        //----------------------------------------------------------------------

        const { activeReply, removeReply } = useReplies();
        const { isSendPending, message } = useChatInput();
        const { sendMessage } = useSendMessage();
        return {
            selectedTemplate,
            isTemplate,
            hasMediaTemplateFilesUploaded,
            dropZoneRef,
            chatsStore,
            isOverDropZone,
            isSendPending,
            message,
            sendMessage,
            activeReply,
            removeReply,
            isChatAssignedToMeV21,
            shouldAssignV21,
            channelsStore,
            uploadFiles,
            customerSettings,
        };
    },
});
